var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('polygon',{attrs:{"points":"0,2 45,4 70,4 70,0 75,0 75,16 70,16 70,12 45,12 0,14","fill":"white","stroke":"#ababab","stroke-width":".5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }